import ComponentUnderMaintenance from './ComponentUnderMaintenance'
import MaintenanceMode from './MaintenanceMode'

export default MaintenanceMode

export { ComponentUnderMaintenance }
